module.exports = __webpack_public_path__ + "img/information.01eca34b.svg";